import { useContext } from 'react';
import { TermFilterContext } from '@/containers/Project.Terms';

export const useIsTermActive = (props: { termValue: string }) => {
  const { highlightTerm } = useContext(TermFilterContext);

  return highlightTerm === props?.termValue;
};